<template>
  <div class="report-section report-section-resource-overview">
    <div v-if="reportData.options?.name || reportData.name" class="section-title">{{ reportData.options?.name || reportData.name }}</div>
    <div v-if="reportData.options?.description || reportData.description" class="section-description">{{ reportData.options?.description || reportData.description }}</div>
    <usage
      isTemplate
      :resource="resource"
      :resId="resId"
      :scopeParams="scopedParams" />
  </div>
</template>

<script>
import Usage from '@Cloudenv/sections/UsageSidepage'

export default {
  name: 'ReportResourceOverview',
  components: {
    Usage,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
    }
  },
  computed: {
    resId () {
      if (this.scopeParams.project_id) {
        return this.scopeParams.project_id
      }
      if (this.scopeParams.domain_id) {
        return this.scopeParams.domain_id
      }
      return ''
    },
    resource () {
      if (this.scopeParams.project_id) {
        return 'projects'
      }
      if (this.scopeParams.domain_id) {
        return 'domains'
      }
      return ''
    },
    scopedParams () {
      const params = { scope: this.scopeParams.scope || this.$store.getters.scope }
      if (this.scopeParams.project_id) {
        params.scope = 'project'
        params.project_id = this.scopeParams.project_id
      }
      if (this.scopeParams.domain_id) {
        params.scope = 'domain'
        params.domain_id = this.scopeParams.domain_id
      }
      return params
    },
  },
  methods: {
    getTemplateParams () {
      return {}
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 15px;
}
.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
